import React from "react";

type IconProps = React.SVGProps<SVGSVGElement>;

export const HeaderMenuEditProfileIcon = (props: IconProps) => (
  <svg
    width="39"
    height="39"
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H31C35.4183 0 39 3.58172 39 8V31C39 35.4183 35.4183 39 31 39H8C3.58172 39 0 35.4183 0 31V8Z"
      fill="white"
    />
    <path
      d="M22.1066 17.48L20.9281 16.3015L13.1667 24.0629V25.2414H14.3452L22.1066 17.48ZM23.2851 16.3015L24.4636 15.123L23.2851 13.9445L22.1066 15.123L23.2851 16.3015ZM15.0355 26.9081H11.5V23.3725L22.6958 12.1767C23.0213 11.8513 23.5489 11.8513 23.8743 12.1767L26.2314 14.5337C26.5568 14.8592 26.5568 15.3868 26.2314 15.7122L15.0355 26.9081Z"
      fill="#181818"
    />
  </svg>
);

export const HeaderMenuAccountIcon = (props: IconProps) => (
  <svg
    width="39"
    height="39"
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H31C35.4183 0 39 3.58172 39 8V31C39 35.4183 35.4183 39 31 39H8C3.58172 39 0 35.4183 0 31V8Z"
      fill="white"
    />
    <path
      d="M16.2387 12.8332L18.4109 10.6611C18.7363 10.3356 19.2639 10.3356 19.5894 10.6611L21.7615 12.8332H24.8334C25.2937 12.8332 25.6668 13.2063 25.6668 13.6666V16.7385L27.8389 18.9107C28.1644 19.2361 28.1644 19.7638 27.8389 20.0892L25.6668 22.2613V25.3333C25.6668 25.7935 25.2937 26.1666 24.8334 26.1666H21.7615L19.5894 28.3388C19.2639 28.6642 18.7363 28.6642 18.4109 28.3388L16.2387 26.1666H13.1668C12.7065 26.1666 12.3334 25.7935 12.3334 25.3333V22.2613L10.1613 20.0892C9.83581 19.7638 9.83581 19.2361 10.1613 18.9107L12.3334 16.7385V13.6666C12.3334 13.2063 12.7065 12.8332 13.1668 12.8332H16.2387ZM14.0001 14.4999V17.4288L11.929 19.4999L14.0001 21.571V24.4999H16.929L19.0001 26.571L21.0712 24.4999H24.0001V21.571L26.0712 19.4999L24.0001 17.4288V14.4999H21.0712L19.0001 12.4288L16.929 14.4999H14.0001ZM19.0001 22.8333C17.1591 22.8333 15.6668 21.3408 15.6668 19.4999C15.6668 17.659 17.1591 16.1666 19.0001 16.1666C20.841 16.1666 22.3334 17.659 22.3334 19.4999C22.3334 21.3408 20.841 22.8333 19.0001 22.8333ZM19.0001 21.1666C19.9206 21.1666 20.6668 20.4204 20.6668 19.4999C20.6668 18.5794 19.9206 17.8333 19.0001 17.8333C18.0796 17.8333 17.3334 18.5794 17.3334 19.4999C17.3334 20.4204 18.0796 21.1666 19.0001 21.1666Z"
      fill="#181818"
    />
  </svg>
);

export const HeaderMenuTimelineIcon = (props: IconProps) => (
  <svg
    width="39"
    height="39"
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H31C35.4183 0 39 3.58172 39 8V31C39 35.4183 35.4183 39 31 39H8C3.58172 39 0 35.4183 0 31V8Z"
      fill="white"
    />
    <path
      d="M19.8195 14.7048V19.8195L23.2293 21.5244M28.3441 19.8195C28.3441 24.5275 24.5275 28.3441 19.8195 28.3441C15.1115 28.3441 11.2949 24.5275 11.2949 19.8195C11.2949 15.1115 15.1115 11.2949 19.8195 11.2949C24.5275 11.2949 28.3441 15.1115 28.3441 19.8195Z"
      stroke="#181818"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const HeaderMenuContinueWatchingIcon = (props: IconProps) => (
  <svg
    width="39"
    height="39"
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H31C35.4183 0 39 3.58172 39 8V31C39 35.4183 35.4183 39 31 39H8C3.58172 39 0 35.4183 0 31V8Z"
      fill="white"
    />
    <path
      d="M13.8523 13.8437C13.8523 13.0158 13.8523 12.6018 14.0249 12.3737C14.1753 12.1749 14.4051 12.0519 14.6539 12.037C14.9396 12.02 15.284 12.2496 15.9728 12.7088L24.9369 18.6849C25.5061 19.0643 25.7906 19.254 25.8898 19.4932C25.9765 19.7022 25.9765 19.9372 25.8898 20.1463C25.7906 20.3854 25.5061 20.5751 24.9369 20.9546L15.9728 26.9306C15.284 27.3899 14.9396 27.6195 14.6539 27.6024C14.4051 27.5876 14.1753 27.4645 14.0249 27.2658C13.8523 27.0376 13.8523 26.6236 13.8523 25.7958V13.8437Z"
      stroke="#181818"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const HeaderMenuSupportIcon = (props: IconProps) => (
  <svg
    width="39"
    height="39"
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H31C35.4183 0 39 3.58172 39 8V31C39 35.4183 35.4183 39 31 39H8C3.58172 39 0 35.4183 0 31V8Z"
      fill="white"
    />
    <path
      d="M13.5454 22.5003L9.83331 25.417V12.5003C9.83331 12.0401 10.2064 11.667 10.6666 11.667H23.1666C23.6269 11.667 24 12.0401 24 12.5003V22.5003H13.5454ZM12.969 20.8337H22.3333V13.3337H11.5V21.9879L12.969 20.8337ZM15.6666 24.167H24.1976L25.6666 25.3212V16.667H26.5C26.9602 16.667 27.3333 17.0401 27.3333 17.5003V28.7503L23.6212 25.8337H16.5C16.0397 25.8337 15.6666 25.4606 15.6666 25.0003V24.167Z"
      fill="#181808"
    />
  </svg>
);

export const HeaderMenuLogoutIcon = (props: IconProps) => (
  <svg
    width="39"
    height="39"
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H31C35.4183 0 39 3.58172 39 8V31C39 35.4183 35.4183 39 31 39H8C3.58172 39 0 35.4183 0 31V8Z"
      fill="white"
    />
    <path
      d="M13.1666 27.8337C12.7064 27.8337 12.3333 27.4606 12.3333 27.0003V12.0003C12.3333 11.5401 12.7064 11.167 13.1666 11.167H24.8333C25.2936 11.167 25.6666 11.5401 25.6666 12.0003V14.5003H24V12.8337H14V26.167H24V24.5003H25.6666V27.0003C25.6666 27.4606 25.2936 27.8337 24.8333 27.8337H13.1666ZM24 22.8337V20.3337H18.1666V18.667H24V16.167L28.1666 19.5003L24 22.8337Z"
      fill="#181818"
    />
  </svg>
);

export const HeaderMenuSubscriptionIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H31C35.4183 0 39 3.58172 39 8V31C39 35.4183 35.4183 39 31 39H8C3.58172 39 0 35.4183 0 31V8Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.4374 12.2725C20.7641 11.2425 19.2359 11.2425 18.5626 12.2725L15.1632 17.4727L12.5648 16.0006C11.263 15.263 9.69785 16.4189 10.0505 17.8573L11.8158 25.0584C11.8952 25.3827 12.1896 25.6111 12.5281 25.6111H27.4719C27.8104 25.6111 28.1048 25.3827 28.1843 25.0584L29.9495 17.8573C30.3022 16.4189 28.737 15.263 27.4352 16.0006L24.8368 17.4727L21.4374 12.2725ZM20.2053 13.0548C20.1092 12.9077 19.8908 12.9077 19.7947 13.0548L16.0179 18.8322C15.8065 19.1556 15.3751 19.2589 15.0367 19.0672L11.8343 17.2529C11.6484 17.1475 11.4248 17.3126 11.4751 17.5181L13.1049 24.1666H26.8951L28.5249 17.5181C28.5752 17.3126 28.3517 17.1475 28.1657 17.2529L24.9633 19.0672C24.6249 19.2589 24.1935 19.1556 23.9821 18.8322L20.2053 13.0548Z"
      fill="#181818"
    />
    <path
      d="M13.1603 27.0555C12.7556 27.0555 12.4275 27.3789 12.4275 27.7778C12.4275 28.1766 12.7556 28.5 13.1603 28.5H26.8397C27.2444 28.5 27.5725 28.1766 27.5725 27.7778C27.5725 27.3789 27.2444 27.0555 26.8397 27.0555H13.1603Z"
      fill="#181818"
    />
  </svg>
);

export const HeaderMenuCoinsIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H31C35.4183 0 39 3.58172 39 8V31C39 35.4183 35.4183 39 31 39H8C3.58172 39 0 35.4183 0 31V8Z"
      fill="white"
    />
    <path
      d="M19.0041 13.3359C24.0667 13.3359 28.1708 15.5745 28.1708 18.3359V21.6693C28.1708 24.4307 24.0667 26.6693 19.0041 26.6693C14.0319 26.6693 9.98429 24.5099 9.84131 21.8167L9.8374 21.6693V18.3359C9.8374 15.5745 13.9415 13.3359 19.0041 13.3359ZM19.0041 23.3359C15.9037 23.3359 13.1628 22.4963 11.5039 21.2113L11.5041 21.6693C11.5041 23.2378 14.7396 25.0026 19.0041 25.0026C23.1797 25.0026 26.3688 23.3105 26.4999 21.7675L26.5041 21.6693L26.5051 21.2107C24.8463 22.4961 22.105 23.3359 19.0041 23.3359ZM19.0041 15.0026C14.7396 15.0026 11.5041 16.7674 11.5041 18.3359C11.5041 19.9044 14.7396 21.6693 19.0041 21.6693C23.2686 21.6693 26.5041 19.9044 26.5041 18.3359C26.5041 16.7674 23.2686 15.0026 19.0041 15.0026Z"
      fill="#181818"
    />
  </svg>
);
